import axios from 'axios';
import config from '../../config';

const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

const contactService = {
  getContactInfo: async () => {
    try {
      const response = await api.get('/contact-info');
      return response.data;
    } catch (error) {
      console.error('Error fetching contact info:', error);
      return {
        address: '',
        addressLink: '',
        phone: '',
        email: '',
        hours: { weekday: '', weekend: '' }
      };
    }
  },

  updateContactInfo: async (contactInfo) => {
    const response = await api.put('/contact-info', contactInfo);
    return response.data;
  }
};

export default contactService;